import React, { Component } from 'react'; 
import PersonalPaymentCompletePopup from '../modules/popup/PersonalPaymentCompletePopup';

class PersonalPaymentCompletePage extends Component {
  render() {
    return (
      <div id='page-wrapper' className="container" style={{backgroundColor: '#ffffff', display: "flex", flexDirection: "column", minHeight: "100vh", justifyContent: "center"}}>
        <div style={{marginBottom: "39px"}}>
            <PersonalPaymentCompletePopup
                isPopup={true}
                // isClose={true}
            />
        </div>
      </div>
    );
  }
}

export default PersonalPaymentCompletePage;